<ng-container>
  <div *ngIf='attachments?.length > 0 || attachWithButton'
       [ngClass]="{'border-0': hideBorders}"
       class='pt-input-attachments'>
    <ng-container *ngFor='let attachment of attachments; index as i'>
      <div *ngIf='title' class='d-inline-flex mb-2'>
        <div class='pt-input-attachment-title me-3'>
          {{ title }}
        </div>
        <div (click)='attachmentExample.emit()' class='btn btn-link btn-link-custom'>
          {{ "BUTTON.EXAMPLE" | translate }}
        </div>
      </div>
      <div [ngClass]='{"mt-3": i > 0}' class='pt-input-attachments-container'>
        <pt-icon [iconType]='SVG'
                 [key]='attachment?.attachmentType?.toLowerCase() + ".svg"'
                 [size]='30'
        ></pt-icon>

        <div class='attachment font-12'>
          <div [container]='"body"'
               [ngbTooltip]='attachment?.name'
          >{{ attachment?.name ? attachment?.name : noAttachmentMessage }}
          </div>

          <div [ngbTooltip]='attachment?.checksum' class='checksum text-muted'
               container='body'
          >{{ "LABELS.CHECKSUM" | translate }}: {{ attachment?.checksum ? attachment?.checksum : '' }}
          </div>
        </div>

        <div [ngClass]='{"me-1": attachWithButton}' class='actions-container'>
          <ng-container *ngxPermissionsOnly="PtPermissions.MANAGE_WORKSPACE">
            <button (click)='deleteAttachment.emit(attachment)'
                    *ngIf='showDelete || attachWithButton'
                    [disabled]="disabledDelete" class='btn btn-sm btn-outline-danger d-flex align-items-end ps-1'>
              <pt-icon [key]='IconTrash'></pt-icon>
              <span>{{ "BUTTON.DELETE" | translate }}</span>
            </button>
          </ng-container>
          <div (click)='downloadAttachment.emit(attachment)'
               *ngIf='showDownload || attachWithButton' class='btn btn-sm btn-outline-secondary d-flex align-items-end ps-1 ms-1'>
            <pt-icon [key]='IconDownload'></pt-icon>
            <span>{{ "BUTTON.DOWNLOAD" | translate }}</span>
          </div>
        </div>

        <div *ngIf='attachWithButton' class='actions-container'>
          <div (click)='uploadAttachment()'
               *ngxPermissionsOnly="PtPermissions.MANAGE_WORKSPACE" class='btn btn-sm btn-outline-primary d-flex align-items-end'>
            <pt-icon [key]='IconUpload'></pt-icon>
            <span>{{ "BUTTON.LOAD" | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf='!attachments && attachWithButton'>
      <div *ngIf='title' class='d-inline-flex mb-2'>
        <div class='pt-input-attachment-title me-3'>
          {{ title }}
        </div>
        <div (click)='attachmentExample.emit()' class='btn btn-link btn-link-custom'>
          {{ "BUTTON.EXAMPLE" | translate }}
        </div>
      </div>

      <div class='pt-input-attachments-container'>
        <div class='attachment'>
          <span>{{ noAttachmentMessage }}</span>
        </div>

        <div *ngIf='attachWithButton' class='actions-container'>
          <div (click)='uploadAttachment()'
               *ngxPermissionsOnly="PtPermissions.MANAGE_WORKSPACE" class='btn btn-sm btn-outline-primary d-flex align-items-center'>
            <pt-icon [key]='IconUpload'></pt-icon>
            <span>{{ "BUTTON.LOAD" | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div *ngIf='!attachWithButton && !readonly'>
    <span (click)='uploadAttachment()'
          *ngxPermissionsOnly="PtPermissions.MANAGE_WORKSPACE else NoAddPermissionAndEmptyList"
          [ngClass]="{'input-attachment-disabled': disabledAdd} "
          class='btn btn-sm btn-link row'>
      <pt-icon [key]='IconAttach'></pt-icon>
      {{ "BUTTON.ADD" | translate }}
    </span>
  </div>
</ng-container>

<ng-template #NoAddPermissionAndEmptyList>
  <div *ngIf="attachments?.length === 0" class="text-muted">{{ 'MESSAGE.NO_ATTACHMENTS_AVAILABLE' | translate }}</div>
</ng-template>
